import { Offcanvas } from "react-bootstrap";
import CustomerLandingPage from "../../LandingPage/CustomerLandingPage";

const PagePreview = ({ show, hide, title, pageId }) => {
  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 1024 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <CustomerLandingPage pageId={pageId} />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PagePreview;